import $ from 'jquery';
import 'slick-carousel';

$(() => {
    const $homePushSliders = $('.home-push__slider');

    $homePushSliders.each((i, el) => {
        $(el).slick({
            rows: 0,
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: parseInt($(el).data('slides')) || 2,
            slidesToScroll: parseInt($(el).data('slides')) || 2,
            autoplay: false,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: parseInt($(el).data('slides')) || 1,
                    slidesToScroll: parseInt($(el).data('slides')) || 1,
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: parseInt($(el).data('slides')) || 2,
                    slidesToScroll: parseInt($(el).data('slides')) || 2
                }
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: parseInt($(el).data('slides')) || 1,
                    slidesToScroll: parseInt($(el).data('slides')) || 1
                }
            }]
        });
    });

    $(document).on('click', '.js-realisation-modal-link', function (e) {
        e.preventDefault();

        $('#realisation-modal .js-image').html(`<img class="img-fluid" src="${$(this).data('img')}" />`);
        $('#realisation-modal .js-title').html($(this).data('title'));
        $('#realisation-modal .js-content').html($(this).data('content'));
        $('#realisation-modal').modal('show');
    });

    $(document).on('submit', '.header-main__location-form', function (e) {
        e.preventDefault();
        $(e.currentTarget).find('.alert-warning').remove();
        const url = $('.js-location-block--input-event').val();
        if (url == "") {
            $(e.currentTarget).prepend('<div class="alert alert-warning col-12">Choisissez un évènement pour votre animation avant de commencer votre réservation</div>');

        } else {
            window.location = url;
        }
        return false;
    });
});





// WEBPACK FOOTER //
// ./themes/maisondubillard/_dev/js/index.js